module.exports = __webpack_public_path__ + "static/media/  (152).3f9a7057.jpg";